<template>
  <div class="home">
    {{title}}
  </div>
</template>

<script>
  import {mapMutations} from "vuex";
  import {ssoApi} from "@/api/organization";
  import {userApi} from "../api/organization";

  export default {
    name: 'Home',
    data() {
      return {
        title: '',
        moduleId: ""
      }
    },
    created() {
      // this.loadUser();
      this.moduleId = this.$route.params.moduleId;

      // this.listUserRights(pageType);
      this.toPage();
    },
    methods: {
      ...mapMutations(["changeLogin", "signout", "updateCurrentSubject","saveToken","changeUserRight"]),
      loadUser() {
        const token = this.$route.query.token;
        ssoApi.login({
          token: this.$route.query.token
        }).then(r=>{
          if(r.data.result === 0){
            const rd = r.data.data;
            this.changeLogin(rd);
            this.saveToken(token);
            const pageType = this.$route.params.type;
            this.listUserRights(pageType);
          }
        })
      },
      listUserRights(pageType){
        userApi.listUserRights(pageType).then(r => {
          if(r.data.result == 0){
            const rData = r.data.data;
            this.changeUserRight(rData);
            this.toPage(pageType);
            // this.$router.push("/page");
          }
        })
      },
      toPage(){
        sessionStorage.setItem('menuId', this.moduleId);
        this.$router.push("/page");
      }
    }
}
</script>
